const sharedTokens = {
  ILocalizedStringProvider: Symbol(),
  IAuthStore: Symbol(),
}

export default sharedTokens